<template>
	<inertia-head title="TRC COUPLES Management" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">TRC AI CIRCLE Content Management</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">TRC AI CIRCLE Management List</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="mb-4">
			<form @submit.prevent="searchRecords">
				<div class="row">
					<div class="col-md-9 mb-4">
						<div class="input-group">
							<input v-model="form.search" type="text" id="search" name="search" class="form-control" placeholder="Search" />
							<span class="input-group-btn">
								<button
									type="submit"
									class="btn btn-secondary"
									:disabled="!form.isDirty || form.processing"
								>
									<i class="fa fa-search me-1"></i>Search
								</button>
							</span>
						</div>
					</div>
					<div class="col space-x-1 mb-4 text-end">
						<button type="button" @click="viewTRCAiCircleContentModal(0,'add')" class="btn btn-alt-primary">
							<i class="fa fa-plus me-1"></i>
							Add Content
						</button>
					</div>
				</div>
			</form>
		</div>

		<div class="block block-rounded">
			<div class="block-content block-content-full">
				<!-- Pagination -->
				<pagination v-if="contents.data.length > 0" :collections="contents"/>
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead>
							<tr>
								<th>TITLE</th>
								<th>VIMEO ID</th>
								<th>DATE START</th>
								<th>CREATED</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(content, c_index) in contents.data"
								:key="content.sub_content_id"
							>
								<td>{{content.title}}</td>
								<td>{{content.vimeo_id}}</td>
								<td>{{content.date_start}}</td>
								<td>{{content.created_at}}</td>
								<td class="text-end">
									<button @click="viewTRCAiCircleContentModal(c_index,'update')" type="button" class="btn btn-sm btn-alt-info"><i class="fa fa-pencil-alt"></i></button>
								</td>
							</tr>
							<tr v-if="contents.data.length <= 0">
								<td colspan="5" class="mb-0 fw-semibold text-center p-5">NO TRC AI CIRCLE CONTENT FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="contents.data.length > 0" :collections="contents"/>
			</div>
		</div>
		<add-update-trc-ai-circle-content ref="addUpdateTRCAiCircleContentModal" :content="selectedTRCAiCircleContent"/>
	</div>
</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3';
import AuthLayout from '../../../Layouts/AuthLayout'
import AddUpdateTrcAiCircleContent from '../../../Components/Admin/AddUpdateTRCAiCircleContent'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia';

export default {
	layout: AuthLayout,
	props: {
		search		: String,
		contents	: Object,
		api_response: Object
	},
	components:{AddUpdateTrcAiCircleContent},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const action = ref('add');

		const toast = createToaster();

		const selectedTRCAiCircleContent = reactive({});

		const addUpdateTRCAiCircleContentModal = ref(null);

		const form = useForm({
			search 		: props.search,
		})

		const searchRecords = () => {

			Inertia.get(route('admin.trc-ai-circle.contents',{
					search 		: form.search
				})
			)
		}

		const viewTRCAiCircleContentModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedTRCAiCircleContent.ai_circle_content_uuid 	= props.contents.data[_index].ai_circle_content_uuid;
				selectedTRCAiCircleContent.title 					= props.contents.data[_index].title;
				selectedTRCAiCircleContent.vimeo_id 				= props.contents.data[_index].vimeo_id;
				selectedTRCAiCircleContent.description 			= props.contents.data[_index].description;
				selectedTRCAiCircleContent.date_start 			= props.contents.data[_index].date_start;
				selectedTRCAiCircleContent.status 				= props.contents.data[_index].status;
			}

			addUpdateTRCAiCircleContentModal.value.setAiCircleContent(_action,selectedTRCAiCircleContent);

			addUpdateTRCAiCircleContentModal.value.toggleModal();

		}
	

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action=='add' ? 'added' : 'updated';

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "danger"});
				}
			}
		})

		return{
			form,
			action,
			toast,
			searchRecords,
			viewTRCAiCircleContentModal,
			selectedTRCAiCircleContent,
			addUpdateTRCAiCircleContentModal
		}
	},
}
</script>
